exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.disabled[data-v-84f483b4] {\n    pointer-events: none;\n    opacity: 0.6;\n    cursor: not-allowed;\n}\nspan.nearbutton-style[data-v-84f483b4] \n{\n    color:red;\n    margin-left:10px;\n}\n", ""]);

// exports
